<template>
  <div class = 'col-md-12'>
    <div class = 'row'>
      <div class = 'col-md-12 mb-4'>
        <div id = 'header_img'><img src='../assets/images/home.png'/> </div>
      </div>
    </div>
    <div class = 'row'>
      <div class = 'col-md-12 mb-3'>
        <h3>PhD Openings (MAT, CS)</h3>
        <p>ECL is seeking PhD students in Media Arts and Technology and Computer Science for the 2022-2023 academic year. Candidates should have a solid technical background and a strong interest in art, design, craft, or manufacturing applications of computation. We are particularly interested in students who have interests and skills in some combination of the following domains:</p>
        <ul>

          <li>Developing technologies and techniques that integrate computational design and digital fabrication.</li>
          <li>Developing new programming languages and environments for artists, designers, and craftspeople.</li>
          <li>Efforts to broaden participation in computer science and computational production.</li>
          <li>Developing new authoring tools for immersive technologies (AR,VR,XR).</li>
          <li>Researching the social and cultural implications of emerging forms of technological production.</li>
          <li>Developing culturally relevant approaches to computational production and making.</li>

        </ul>

        <h3>MS Openings (MAT, CS)</h3>

        <p>ECL is always looking for outstanding MS students to contribute to research in the lab.  Students interested in a research assistantship should email Professor Jacobs describing their background, experience, anticipated date of graduation, and research or career goals. Please also include a list of the courses you have taken (and grades received, unofficial transcripts preferred) and a resume. Attach copies of any papers that you have published in English.</p>

        <h3>All Candiates</h3>
        <p>
          We are especially interested in candidates who can contribute to the diversity and excellence of the academic community through research, teaching and service. The University of California is an Equal Opportunity/Affirmative Action Employer and all qualified applicants will receive consideration for employment without regard to race, color, religion, sex, sexual orientation, gender identity, national origin, disability status, protected veteran status, or any other characteristic protected by law.
        </p>

        <p>
          Prospective students should apply to the program that best aligns with their prior education. Individuals coming from interdisciplinary, art, or design backgrounds should apply to  Media Arts and Technology. Individuals from computer science should apply to either Media Arts and Technology or Computer Science. Please mention your interest in our lab and in working with Jennifer Jacobs in your application.
        </p>

        <p>
          For more information about the PhD program in Media Arts and Technology or Computer Science check out the <a href="https://www.mat.ucsb.edu/admissions/">MAT</a> and <a href="https://cs.ucsb.edu/education/grad/admissions">CS</a> department websites.
        </p>
      </div>
    </div>

</div>
</template>

<script>
export default {
  name: 'contact'
}
</script>
